// ドラッグ&ドロップゾーンコンポーネント

import React from 'react';
import Icon from './Icon';

interface DropZoneProps {
  isDragging: boolean;
  onDragOver: (e: React.DragEvent) => void;
  onDragLeave: (e: React.DragEvent) => void;
  onDrop: (e: React.DragEvent) => void;
  onFileSelect: (files: File[]) => void;
  disabled?: boolean;
  multiple?: boolean;
}

const DropZone: React.FC<DropZoneProps> = ({
  isDragging,
  onDragOver,
  onDragLeave,
  onDrop,
  onFileSelect,
  disabled = false,
  multiple = true,
}) => {
  const handleFileInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      const files = Array.from(event.target.files);
      onFileSelect(files);
    }
  };

  return (
    <div
      className={`
        border-dashed text-center transition-all
        ${isDragging ? 'border-blue-500 bg-blue-50' : 'border-gray-300 bg-white'}
        ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer hover:border-gray-400'}
      `}
      style={{
        height: '120px',
        borderRadius: '8px',
        borderWidth: '2px',
        borderStyle: 'dashed',
        opacity: 1,
        padding: '24px'
      }}
      onDragOver={onDragOver}
      onDragLeave={onDragLeave}
      onDrop={onDrop}
    >
      <div className="flex flex-col items-center justify-center h-full">
        {/* アップロードアイコン */}
        <div className="mb-2">
          <svg className="w-10 h-10 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
          </svg>
        </div>

        {/* テキスト */}
        <div className="text-center">
          <p className="text-base text-gray-700 mb-1">
            <label className="cursor-pointer">
              <span style={{ color: '#2563EB' }}>
                クリックしてファイルを選択
              </span>
              <input
                type="file"
                multiple={multiple}
                className="hidden"
                onChange={handleFileInput}
                disabled={disabled}
                accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx"
              />
            </label>
            {' '}またはドラッグ&ドロップ
          </p>
          <p className="text-xs text-gray-500">
            PDF, Word, Excel, PowerPoint (最大10MB)
          </p>
        </div>
      </div>
    </div>
  );
};

export default DropZone;
